import { Injectable } from "@angular/core";
import { DbTableDefinition } from "src/app/_services/persistence/db-persistence/db-table-definition";

@Injectable({
  providedIn: 'root'
})
export class CargoItemTypeDbTableDefinition extends DbTableDefinition {
    tableName = 'cargoItemTypes';
    tableStructure = `(id BIGINT(20) PRIMARY KEY null,
       databag LONGTEXT,
       label TEXT NOT NULL
      );`;

      constructor() {
        super();
        // Add UpdateStatements to Map
      }
}